import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser, PortalState } from './types';
import { PRODUCTS } from './constants';
import { SESSION_TYPES } from '../../../containers/chat/slice/constants';

export const initialState: PortalState = {
  isSidebarOpen: true,
  chatSessions: [],
  loading: false,
  chatSessionIDToDelete: null,
  currentProduct: PRODUCTS.MENUTIGER,
  historyType: SESSION_TYPES.CHAT,
  reFetchChatSessions: false,
  currentUser: null,
  isCurrentUserLoading: false,
  isLogoutInProgress: false,
  isConnectUserInProgress: false,
  connectedUser: null,
  isAuthenticated: true,
  parentUrl: null,
};

export const portalSlice = createSlice({
  name: 'portal',
  initialState,
  reducers: {
    getCurrentUser(state) {
      state.isCurrentUserLoading = true;
    },
    getCurrentUserSucceeded(state, action: PayloadAction<IUser>) {
      state.currentUser = action.payload;
      state.isCurrentUserLoading = false;
      if (action.payload.productId === PRODUCTS.QRTIGER) {
        state.currentProduct = PRODUCTS.QRTIGER;
      }
    },
    getCurrentUserFailed(state) {
      state.isCurrentUserLoading = false;
    },
    getChatSessions(state, action: PayloadAction<{ sessionType: (typeof SESSION_TYPES)[keyof typeof SESSION_TYPES]; productId: (typeof PRODUCTS)[keyof typeof PRODUCTS]; userId: string }>) {
      state.loading = true;
    },
    getChatSessionsSucceeded(state, action: PayloadAction<any>) {
      state.chatSessions = action.payload;
      state.loading = false;
    },
    getChatSessionsFailed(state) {
      state.loading = false;
    },

    toggleSidebar(state, action: PayloadAction<boolean | undefined>) {
      state.isSidebarOpen = action.payload !== undefined ? action.payload : !state.isSidebarOpen;
    },

    setChatSessionIDToDelete(state, action: PayloadAction<string | null>) {
      state.chatSessionIDToDelete = action.payload;
    },
    deleteChatSession(state, action: PayloadAction<string>) {
      state.loading = true;
    },
    deleteChatSessionSucceeded(state) {
      state.loading = false;
      state.chatSessions = state.chatSessions.filter((session) => session._id !== state.chatSessionIDToDelete);
      state.chatSessionIDToDelete = null;
    },
    deleteChatSessionFailed(state) {
      state.loading = false;
    },
    getCurrentChatSession(state, action: PayloadAction<string>) {},
    getCurrentChatSessionSucceeded(state, action: PayloadAction<any>) {
      const currentSession = action.payload;
      const currentChatSessionIndex = state.chatSessions.findIndex((session) => session._id === currentSession._id);
      if (currentChatSessionIndex !== -1) {
        state.chatSessions[currentChatSessionIndex] = currentSession;
      } else {
        state.chatSessions = [currentSession, ...state.chatSessions];
      }
    },
    getCurrentChatSessionFailed(state) {
      state.loading = false;
    },
    setCurrentProduct(state, action: PayloadAction<(typeof PRODUCTS)[keyof typeof PRODUCTS]>) {
      state.currentProduct = action.payload;
      state.chatSessions = [];
      state.chatSessionIDToDelete = null;
    },
    changeHistoryType(state, action: PayloadAction<(typeof SESSION_TYPES)[keyof typeof SESSION_TYPES]>) {
      if (state.historyType === action.payload) {
        state.reFetchChatSessions = !state.reFetchChatSessions;
      }
      state.historyType = action.payload;
    },
    logout(state) {
      state.isLogoutInProgress = true;
    },
    logoutSucceeded(state) {
      state.isLogoutInProgress = false;
      state.currentUser = null;
    },
    logoutFailed(state) {
      state.isLogoutInProgress = false;
    },
    connectUser(state, action: PayloadAction<{ email: string }>) {
      state.isConnectUserInProgress = true;
    },
    connectUserSucceeded(state, action: PayloadAction<IUser>) {
      state.connectedUser = action.payload;
      state.isConnectUserInProgress = false;
    },
    connectUserFailed(state) {
      state.isConnectUserInProgress = false;
    },
    disconnectUser(state) {
      state.connectedUser = null;
    },
    setIsAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
    setParentUrl(state, action: PayloadAction<string | null>) {
      state.parentUrl = action.payload;
    },
  },
  extraReducers: (builder) => {
    // builder.addCase(subscriptionActions.reSubscribeSucceeded, (state, action) => {
    //     return { ...state, subscription: action.payload, ...(action.payload.customer ? { currentUser: action.payload.customer } : {}) };
    // });
  },
});
export const { actions: portalActions } = portalSlice;
export const usePortalSlice = () => {
  return { actions: portalSlice.actions };
};
